export default "__VITE_ASSET__DQ8JwwxE__"